/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectSuitablePatternPathsQueryResult } from '../../models/get-project-suitable-pattern-paths-query-result';

export interface ApiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Params {
  ProjectId?: string;
}

export function apiProjectStagesGetProjectSuitablePatternPathsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectStagesGetProjectSuitablePatternPathsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectStagesGetProjectSuitablePatternPathsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ProjectId', params.ProjectId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectSuitablePatternPathsQueryResult>;
    })
  );
}

apiProjectStagesGetProjectSuitablePatternPathsGet$Plain.PATH = '/api/ProjectStages/GetProjectSuitablePatternPaths';
